import { UpdateAccesOrder } from './update-acces-order.entity';

export class UpdateGrantedAccesOrder extends UpdateAccesOrder {
	constructor() {
		super();
	}
}